import React from 'react';
import { Descriptions, Modal, Table, Typography } from 'antd';
import {
    TREE_CART_DEFAULT_DBH,
    TREE_CART_DEFAULT_HAUL,
    TREE_CART_DEFAULT_LOCATION,
    TREE_CART_DEFAULT_NO_OBST,
    TREE_CART_DEFAULT_PARAMS,
    TREE_CART_DEFAULT_STUMP,
} from '../../../../../services/treeCartService';

export interface TreeCuttingDefaultsModalProps {
    open: boolean;
    onClose: () => void;
}

/** Explains fixed Tree Calculator inputs used for AI tree-cutting $ cut estimates (not shown on cards). */
export function TreeCuttingDefaultsModal({ open, onClose }: TreeCuttingDefaultsModalProps) {
    return (
        <Modal
            title="Tree cutting defaults"
            open={open}
            onCancel={onClose}
            onOk={onClose}
            okText="Close"
            cancelButtonProps={{ style: { display: 'none' } }}
            width={560}
            destroyOnClose
        >
            <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
               These are the default values used for tree cutting estimates in the Excel calculator.
            </Typography.Paragraph>
            <Descriptions bordered size="small" column={1}>
                <Descriptions.Item label="Stump treatment">{TREE_CART_DEFAULT_STUMP}</Descriptions.Item>
                <Descriptions.Item label="Haul wood">{TREE_CART_DEFAULT_HAUL} (= haul wood)</Descriptions.Item>
                <Descriptions.Item label="Tree location">{TREE_CART_DEFAULT_LOCATION}</Descriptions.Item>
                <Descriptions.Item label="DBH band">Tree Diameter Value</Descriptions.Item>
                <Descriptions.Item label="Height band">Tree Height Value</Descriptions.Item>
                <Descriptions.Item label="Obstructions count">{TREE_CART_DEFAULT_NO_OBST}</Descriptions.Item>
            </Descriptions>
        </Modal>
    );
}
